module.exports = __webpack_public_path__ + "img/app-yqs.327612bd.png";